import styled from 'styled-components'

export const IframePdf = styled.iframe`
  height: 80vh;
  width: 100%;
`
